import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AlignCenter = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M25.858 9.936h1.091c0.602 0 1.091 0.449 1.091 1.004v10.038c0 0.554-0.489 1.004-1.091 1.004h-21.818c-0.603 0-1.091-0.45-1.091-1.004v-10.038c0-0.555 0.488-1.004 1.091-1.004h20.727zM21.951 24.992c0.313 0 0.567 0.427 0.567 0.953v0.101c0 0.526-0.254 0.954-0.567 0.954h-11.955c-0.313 0-0.567-0.428-0.567-0.954v-0.101c0-0.526 0.254-0.953 0.567-0.953h11.955zM9.95 7.008c-0.313 0-0.567-0.428-0.567-0.954v-0.1c0-0.526 0.254-0.954 0.567-0.954h11.955c0.313 0 0.567 0.428 0.567 0.954v0.1c0 0.526-0.254 0.954-0.567 0.954h-11.955z" />
  </SvgIcon>
);

export default AlignCenter;
